<template>
  <div class="footer">
    <div class="yfonnter">
      <img src="../images/sylog.png" mode="heightFix" class="yfonnterumg" alt="" srcset="">
      <div class="footermain">
        <div class="yfller">
          <div class="lianxio"> 联系我们</div>
          <div class="lxtem">
            <img src="../images/dianhua.png" class="lxtemimg" alt="" mode="heightFix" srcset="">
            <div class="lxitemtxt">15213568714</div>
          </div>
          <div class="lxtem">
            <img src="../images/xinxi.png" class="lxtemimg" alt="" mode="heightFix" srcset="">
            <div class="lxitemtxt">898425395@qq.com</div>
          </div>
          <div class="lxtem" @click="tokf" >
            <img src="../images/jefus.png" class="lxtemimg" alt="" mode="heightFix" srcset="">
            <div class="lxitemtxt">在线客服</div>
          </div>
        </div>
        <div class="yfrignt" @click="togo">
          <div class="yfrigntitem" style="margin-top: 0;">
            <img src="../images/wenhao.png" class="lxtemimg1" alt="" mode="heightFix" srcset="" >
            <div class="lxitemtxt">{{nav_footer[0]?.name}}</div>
          </div>
          <div class="yfrigntitem">
            <img src="../images/qianb.png" class="lxtemimg1" alt="" mode="heightFix" srcset="">
            <div class="lxitemtxt">{{nav_footer[1]?.name}}</div>
          </div>
          <div class="yfrigntitem">
            <img src="../images/fangz.png" class="lxtemimg1" alt="" mode="heightFix" srcset="">
            <div class="lxitemtxt">{{nav_footer[2]?.name}}</div>
          </div>
          <div class="yfrigntitem">
            <img src="../images/xin.png" class="lxtemimg1" alt="" mode="heightFix" srcset="">
            <div class="lxitemtxt">{{nav_footer[3]?.name}}</div>
          </div>
        </div>
      </div>
      <div class="footerss">为了防范电信网络诈骗，如网民接到962110电话，请立即接听,重庆广巨源科技有限公司</div>
      <div class="footerss footerss1">©2025 REVIVO ALL RIGHTS RESERVED </div>
      <div class="footerss " style="margin-top: 0px;line-height: 19px;">渝ICP备2022008559号-1</div>
      <div class="footerss footerss1">联系我们：898425395@qq.com</div>
    </div>

    <!-- 旧 -->
    <!-- <div class="ft_help">
      <van-collapse v-if="nav_footer != ''" v-model="foothelp" accordion style="margin-bottom: 20px;">
                <div v-for="(value,index) in nav_footer" :key="index" >
                    <van-collapse-item :title="value.name" :name="index">
                        <div class="footer_list">
                            <span v-for="(value1,index1) in value.items" :key="index1">
                                <template v-if="value1.data_type == 'article'">
                                    <router-link :to="{path:'/help', query:{id: value1.value}}">
                                        <span v-html="value1.name"></span>
                                    </router-link>
                                </template>
<template v-if="value1.data_type == 'custom'">
                                    <a :href="value1.url">
                                        <span v-html="value1.name"></span>
                                    </a>
                                </template>
<template v-if="value1.data_type == 'other'">
                                    <a :href="value1.url">
                                        <span v-html="value1.name"></span>
                                    </a>
                                </template>
</span>
</div>
</van-collapse-item>
</div>
</van-collapse>
<div class="footer_list">
  <img src="../assets/icon_1.png" alt="" />
</div>
<div class="foot_payimg">
  <a href="https://b.alipay.com/page/portal/home" target="_blank"><img src="../assets/ty_1.png" alt="" /></a>
  <a href="https://www.hnwx.gov.cn/wxzw/" target="_blank"><img src="../assets/ty_2.png" alt="" /></a>
  <a href="https://www.12377.cn/" target="_blank"><img src="../assets/ty_3.png" alt="" /></a>
  <a href="https://www.12315.cn/" target="_blank"><img src="../assets/ty_5.png" alt="" /></a>
  <a href="" target="_blank"><img src="../assets/ty_4.png" alt="" /></a>
</div>
<div class="foot_bq" :style="{marginBottom: !$route.meta.detailsHide?'20px':'60px'}">
  <p>为了防范电信网络诈骗，如网民接到962110电话，请立即接听 </p>
  <p>重庆翔泽汇科技有限公司</p>
  <p><a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">渝ICP备2025050304号-1</a></p>
  <p>联系我们：a1043263349@foxmail.com</p>
</div>
</div> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      foothelp: "",
      nav_footer: [],
      order_no: "",
      iframeSrc:'https://kf.renguokeji.com/kefu/?app=lishun&amp;extra=eyJpZCI6IjljMjA3Yjk1Y2FhOWUzZWE2NmVlYmIxZjNmNDk0ZjE3IiwidXNlcl9pZCI6IjljMjA3Yjk1Y2FhOWUzZWE2NmVlYmIxZjNmNDk0ZjE3IiwiZGV2aWNlX2lkIjoiOWMyMDdiOTVjYWE5ZTNlYTY2ZWViYjFmM2Y0OTRmMTciLCJwbGF0Zm9ybSI6ImFuZHJvaW'
    };
  },
  created() {
    this.getNav()
    console.log('footernav',this.footernav);
  },
  methods: {
    tokf(){
            window.open(this.iframeSrc)
          },
    getNav() {
        var _self = this;
        this.GET("nav", function (data) {
          if (data.code == 0) {
            _self.nav_footer = data.data.footer;
          }
        });
      },
    togo(){
      this.$router.push('/xiangxiwt')
    },
    searchOrder() {
      if (this.order_no == "") {
        this.$toast("请填写订单号");
        return false;
      }

      this.$router.push({
        path: "searchorder",
        query: { order_no: this.order_no },
      });
    },
  },
};
</script>
<style scoped>
.yfller {
  width: 60%;
  border-right: 1px solid #FFFFFF;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.footerss{
  width: 80%;
  margin-top: 35px;
  font-size: 13px;
  color: #FFFFFF;
  line-height: 22px;
  font-family: PingFang SC, PingFang SC;
}
.footerss1{
  margin-top: 12px;
}
.yfrignt {
  width: 40%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* background: red; */
}

.yfrigntitem {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 15px;
}

.lxitemtxt {
  font-size: 15px;
  color: #FFFFFF;
  margin-left: 10px;
}

.lxtemimg {
  height: 21px;
}
.lxtemimg1 {
  height: 28px;
}

.lxtem {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-top: 20px;
}

.lianxio {
  font-size: 18px;
  color: #FFFFFF;

}

.footermain {
  width: 90%;
  /* height: 200px; */
  /* background: red; */
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
  align-content: center;
}

.yfonnterumg {
  height: 63px;
}

.yfonnter {
  width: 100%;
  margin-top: 30px;
  background-color: #000000;
  padding: 10% 0;
  display: flex;
  flex-direction: column;
  align-items: center;

}

.footer .van-hairline--top-bottom::after,
.footer .van-hairline-unset--top-bottom::after {
  border: none;
}

.ft_help {
  width: 100%;
  margin-top: 30px;

  /* background-color: #f5f6f8; */
}

.footer_list span {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  box-sizing: border-box;
  width: 100%;
  padding: 3px 16px;
  overflow: hidden;
  color: #333;
  font-size: 14px;
  line-height: 24px;
  background-color: #fff;
  border-bottom: 1px solid #f5f8fb;
}

.footer_list span:last-child {
  border-bottom: none;
}

.footer .van-collapse-item .van-cell {
  background-color: #f5f6f8;
  color: #333;
  padding: 10px 0;
}

.footer .van-cell__right-icon {
  color: #9e9e9e;
  margin-right: 16px;
}

.footer .van-cell::after,
.footer .van-collapse-item--border::after {
  left: 0;
  right: 0;
}

.footer .van-collapse-item__content {
  padding: 0;
}

.order_search {
  width: 100%;
  background-color: #f5f6f8;
  color: #333;
  /* padding: 10px 0; */
  border-bottom: 1px solid #ebedf0;
}

.order_search .van-search__content {
  background-color: #fff;
}

.footer_list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0 10px;
}

.footer_list img {
  width: 100%;
  height: auto;
}

.foot_payimg {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 20px 10px;
}

.foot_payimg a {
  width: 19%;
}

.foot_payimg img {
  width: 100%;
  height: auto;
}

.foot_bq {
  font-size: 12px;
  color: #333;
  margin-bottom: 10px;
}

.foot_bq p {
  padding: 0;
  margin: 0;
  margin-bottom: 3px;
}

.foot_bq a,
.foot_bq a:hover,
.foot_bq a:active,
.foot_bq a:visited {
  color: #333;
}
</style>